import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { insightItems } from '../components/Insights/Insights';
import InsightsDetailComponent from '../components/Insights/InsightsDetail';
import { ROUTES } from '../utils/routes';

/**
 * InsightsDetailPage - Dynamic insights detail page with slug parameter
 * 
 * Uses useParams to get the slug from the URL and finds the matching insight.
 */
export default function InsightsDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Find the insight by slug
  const insight = insightItems.find((item) => item.slug === slug);

  // Handle navigate back to insights list
  const handleBack = () => {
    navigate(ROUTES.INSIGHTS);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <InsightsDetailComponent
      insight={insight}
      onBack={handleBack}
    />
  );
}
